import { useState } from "react";
import FullScreenView from "./FullScreenView";
import { Box } from "@mui/material";
import TableCellWithPhotoIconOnHover from "../table/TableCellWithPhotoIconOnHover";
import TableCellWithVideocamIconOnHover from "../table/TableCellWithVideocamIconOnHover";

interface WithFullScreenProps {
  s3Key: string;
  onClickVideoIcon?: () => void;
}

const withFullScreen = <P extends object>(
  WrappedComponent: React.ComponentType<P>
): React.FC<P & WithFullScreenProps> => {
  return (props: P & WithFullScreenProps) => {
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isKeyframeLoaded, setIsKeyframeLoaded] = useState(false);

    const handleFullScreenToggle = () => {
      setIsFullScreen(!isFullScreen);
    };

    return (
      <Box
        sx={{
          position: "relative",
          display: "flex",
          justifyContent: "center",
          width: "100%",
          "& .hoverIcons": {
            display: "none",
            flex: 1,
            cursor: "pointer",
          },
          "&:hover .hoverIcons": {
            display: "flex",
            flex: 1,
            gap: "0.75em",
            position: "absolute",

            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <WrappedComponent
          {...(props as P)}
          onFullScreenToggle={handleFullScreenToggle}
          setKeyframeLoaded={setIsKeyframeLoaded}
        />
        {isFullScreen && (
          <FullScreenView
            imageUrl={props.s3Key}
            onClose={handleFullScreenToggle}
          />
        )}
        {isKeyframeLoaded && (
          <Box className="hoverIcons">
            <TableCellWithPhotoIconOnHover onClick={handleFullScreenToggle} />
            {!!props.onClickVideoIcon && (
              <TableCellWithVideocamIconOnHover
                className="videocamIcon"
                onClick={props.onClickVideoIcon}
              />
            )}
          </Box>
        )}
      </Box>
    );
  };
};

export default withFullScreen;
